import { render } from "./AnnouncementPage.vue?vue&type=template&id=f472868c&scoped=true"
import script from "./AnnouncementPage.vue?vue&type=script&lang=js"
export * from "./AnnouncementPage.vue?vue&type=script&lang=js"

import "./AnnouncementPage.vue?vue&type=style&index=0&id=f472868c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f472868c"]])

export default __exports__